import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { FaHome, FaDice, FaChartLine } from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';
import { useTranslation } from 'react-i18next';

export const Navbar: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLang);
  };

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    { path: '/', icon: <FaHome className="text-sm" />, label: 'Home' },
    {
      path: '/BetGenerationPage',
      icon: <FaDice className="text-sm" />,
      label: 'BetGen',
    },
    {
      path: '/PredictionAccuracyCharts',
      icon: <FaChartLine className="text-sm" />,
      label: 'Accuracy',
    },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <div className="logo-icon-wrapper">
            <GiMeditation className="logo-icon" aria-hidden="true" />
            <div className="logo-pulse" />
          </div>
          <div className="logo-text">
            <span className="logo-brand">
              BetZen<span className="logo-accent">.app</span>
            </span>
            <span className="logo-tagline">Bet with Peace of Mind</span>
          </div>
        </Link>

        {/* Navigation */}
        <ul className="navbar-menu">
          {navItems.map((item) => (
            <li key={item.path} className="navbar-item">
              <Link
                to={item.path}
                className={`navbar-link ${isActive(item.path) ? 'active' : ''}`}
              >
                {item.icon}
                <span className="nav-label">{item.label}</span>
              </Link>
            </li>
          ))}

          {/* Language Toggle */}
          <li className="navbar-item">
            <button
              onClick={toggleLanguage}
              className="lang-toggle"
              aria-label={`Switch to ${i18n.language === 'it' ? 'English' : 'Italian'}`}
            >
              <span className="lang-flag">
                {i18n.language === 'it' ? '🇬🇧' : '🇮🇹'}
              </span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};
